import { isExist, findCurrentComponentPathInLayoutByRectId } from "utils"

export default {
  computed: {
    dataIds() {
      if (this.currentPageLayout?.options?.inDocument === "popover" && !this.curLayoutOptions.innerElement) {
        return this.currentPageLayout.options.sourceIds
      } else {
        return this.$store.state.states.activeID
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    // 当前组件所在通栏
    currentPageLayout() {
      const path = findCurrentComponentPathInLayoutByRectId(
        this.$store.state[this.request_prefix].page.pageLayoutList || [],
        this.ids.rect_id
      )[0]
      let pageLayout = this.getAttrById(
        this.$store.state[this.request_prefix],
        {
          container_id: this.ids.container_id,
          pageLayoutId: path
        },
        "pageLayout"
      )
      return pageLayout
    },
    layoutOptions() {
      if (this.curLayoutOptions.innerElement) {
        return this.curLayoutOptions
      }
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.dataIds, "rect")?.options

      if (
        rectAttr &&
        isExist(this.dataIds.elementInAutoLayoutId) &&
        (isExist(this.dataIds.elementInLayoutId) || isExist(this.dataIds.elementInSwiperId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.dataIds,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent"
      ) {
        return {}
      }
      return rectAttr
    },
    curLayoutOptions() {
      let rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], this.ids, "rect")?.options

      if (
        rectAttr &&
        isExist(this.ids.elementInAutoLayoutId) &&
        (isExist(this.ids.elementInLayoutId) || isExist(this.ids.elementInSwiperId) || isExist(this.ids.elementInDataGridId)) &&
        rectAttr.innerElement === "cxAutoLayout"
      ) {
        rectAttr = this.getAttrById.call(this, this.$store.state[this.request_prefix], {
          ...this.ids,
          elementInLayoutId: undefined
        })
      }
      if (
        rectAttr &&
        rectAttr.pluginName &&
        (rectAttr.pluginName[0] == "loginLayoutComponent" || rectAttr.pluginName[0] === "loginEngineComponentPlugin")
      ) {
        return rectAttr
      }
      if (
        rectAttr &&
        rectAttr.innerElement !== "emptyLayoutComponent" &&
        rectAttr.innerElement !== "layoutComponent" &&
        rectAttr.innerElement !== "swiperComponent" &&
        rectAttr.innerElement !== "cxDataGrid"
      ) {
        return {}
      }
      return rectAttr
    },
    noCacheComponentLayout() {
      // 在四边栏中 不控制
      if (!(this.dataIds?.uid || isExist(this.dataIds?.elementInSwiperId) || this.dataIds?.elementInDataGridId)) return false
      // 数据列表放到列表页使用，一定绑定了数据
      if (this.layoutOptions.innerElement === "cxDataGrid") return true
      return this.layoutOptions.noCacheComponent
    },
    // 上层容器选择多图详情
    multiImageDetail() {
      return this.layoutOptions.multiImageDetail
    },
    // 在四边栏中
    directionTitle() {
      if (isExist(this.ids.directionIndex) && isExist(this.ids.elementInLayoutId) && !isExist(this.ids.uid)) return true
      else return false
    }
  },
  methods: {
    getClassifyData() {
      const datas = this.shareDataPool.getData(
        `layoutRestClassify-${this.ids.container_id}-${this.ids.rect_id}-${this.curLayoutOptions.elementInAutoLayoutId}-${this.curLayoutOptions.path}`
      )
      if (datas) return JSON.parse(datas)
      return []
    }
  }
}
